"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ReplicationRule_1 = require("./_ReplicationRule");
exports._ReplicationRules = {
    type: "list",
    flattened: true,
    member: {
        shape: _ReplicationRule_1._ReplicationRule
    }
};
//# sourceMappingURL=_ReplicationRules.js.map